import { Default, Detail,  List, Create } from "./views";
const Module = {
    name: "audiencesegment",
    defaultRoutePath: "/audiences/audiencesegment",
    menuItemScope: "audience",
    menuItemName: "audienceSegments",

    routes: [
        {
            path: "/audiences/audiencesegment",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
